export const getStageRecommendations = function () {
	const { dimensions, userData, highscoreContent } = this.props;

	/**
	 * 1. Classify the result of the dimension in stage
	 */

	let userStages = {};

	Object.keys(userData.dimensions).map((d) => {
		// Make sure a score for the dimension exists
		if ('score' in userData.dimensions[d] && userData.dimensions[d].score !== false) {
			let score = userData.dimensions[d].score;

			// If any stage exists in this dimension check in which stage the user has reached with his score
			const stages = dimensions[d].stages;
			if (stages.length) {
				for (let i = 0; i < stages.length; i++) {
					// Divides the number of existing stages into steps of equal size and determines the upper limit for the current stage
					const upperStageLimit = (100 / (stages.length + 1)) * (i + 1);

					if (score <= upperStageLimit) {
						// Check if score is smaller than the upper stage limit
						userStages[d] = {
							index: i,
							ratio: (i + 1) / (stages.length + 1),
						};
						break;
					} else if (i === stages.length - 1) {
						// If the score was always higher than the previous stage limits it must be in the highest stage
						userStages[d] = {
							ratio: 1, // same as: (i + 1) / (stages.length)
						};
					}
				}
			}
		}
	});

	// Only continue if any dimension score could be classified in a stage
	if (!Object.keys(userStages).length) {
		return {};
	}

	/**
	 * 2. Check in which dimension the user is in the lowest stage
	 */

	let [highestStageValue, lowStageDimensions] = [1, []];
	for (let dimension in userStages) {
		let value = userStages[dimension].ratio;
		const obj = {
			dimension: dimension,
			priority: dimensions[dimension].priority,
		};

		// Check if value if lower than the currently set highest value
		if (value < highestStageValue) {
			highestStageValue = value;
			lowStageDimensions = [obj];
		} else if (value === highestStageValue) {
			lowStageDimensions.push(obj);
		}
	}

	/**
	 * 3. Return the recommendations from this stage / If the user is already in the highest stage return the highscore text
	 */

	if (highestStageValue === 1) {
		// User is in the highest stage in all dimensions
		// Return the highscore recommendation object
		return highscoreContent;
	} else {
		// There is a single lowest stage of all dimensions
		// OR there are multiple stages that are equally low (potentially all stages even have the same value)

		let d = lowStageDimensions[0].dimension;

		if (lowStageDimensions.length > 1) {
			// Check the dimension's priorities.
			// Hint: If there are multiple dimensions with equally high priorities the recommendation will be delievered from the first dimension in the loop
			let maxPriority = 0;
			lowStageDimensions.forEach((obj, i) => {
				if (obj.priority > maxPriority) {
					d = lowStageDimensions[i].dimension;
					maxPriority = obj.priority;
				}
			});
		}

		return dimensions[d].stages[userStages[d].index];
	}
};

export const getRandomInt = function (max) {
	return Math.floor(Math.random() * max);
};

export const getContact = function () {
	const { contacts, userData } = this.props;

	if ('contact' in userData) {
		return userData.contact in contacts ? contacts[userData.contact] : false;
	} else {
		const length = Object.keys(contacts).length;
		if (!length) {
			// There are no contacts to show so immediately return
			return false;
		} else if (length > 1) {
			// Choose any contact by random and save it in the userData
			const randomKey = Object.keys(contacts)[getRandomInt(length)];
			this.props.updateUserContact(randomKey);
			return contacts[randomKey];
		} else {
			// Return the only contact
			return contacts[Object.keys(contacts)[0]];
		}
	}
};

export const updateUserContact = function (contactKey) {
	this.setState({
		userData: {
			...this.state.userData,
			contact: contactKey,
		},
	});
};
